import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined
export const isSupabaseConfigured = Boolean(url && anonKey)
export const missingSupabaseEnvMessage =
  'Authentication is temporarily unavailable because this deploy is missing Supabase configuration.'

if (!isSupabaseConfigured) {
  console.warn(
    '[vice] Supabase env vars missing — set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY in .env. Auth features are disabled.',
  )
}

// `createClient` validates `supabaseUrl` and throws on empty / malformed
// values. In CI builds where the secret may not be set yet (e.g. forked
// PRs, fresh clones) we hand it a safe placeholder so the React tree still
// mounts and the public site renders. Callers are expected to short-circuit
// before making auth requests when env is missing.
const SAFE_URL_FALLBACK = 'https://placeholder.supabase.invalid'

export const supabase = createClient(url || SAFE_URL_FALLBACK, anonKey || 'placeholder', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
})
